export default __webpack_public_path__ + "static/media/M31.68f5c74c.svg";